import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reportingfilter',
  standalone: false
})
export class ReportingfilterPipe implements PipeTransform {
  seasonby: boolean = false;
  deliveryby: boolean = false;
  transform(value: any, filter: any) {
    if (!value) return [];
    return value.filter((obj: any) => {
      if (filter.filterbyseason && filter.filterbyseason.length > 0) {
        this.seasonby = filter.filterbyseason.some((type: any) =>

          obj.season.toLowerCase().includes(type.toLowerCase())

        );
      }
      else {
        this.seasonby = true;
      }
      // if (filter.filterbyaddress.length > 0) {
      //   this.deliveryby = filter.filterbyaddress.some((type: any) =>

      //     obj.locationName.toLowerCase().match(type.toLowerCase()) && obj.locationName.toLowerCase().startsWith(type.toLowerCase())

      //   );
      // }
      if (filter.filterbyaddress.length > 0) {
        this.deliveryby = filter.filterbyaddress.some((type: any) => {
          const selected = (type ?? '').trim().toLowerCase();
          // empty string represents the "All" selection -> match every location
          if (selected === '') {
            return true;
          }
          return (obj.locationName ?? '').trim().toLowerCase() === selected;
        });
      }
      else {
        this.deliveryby = true;
      }


      return this.seasonby && this.deliveryby;
    });
  }

}
